<template>
    <article class="intro__slide" v-if="view == 'home'">

        <header>

            <IntroSlideTitle 
                :lines="getHeader" 
                @complete="handleIntroDelay" 
            />
            <AnimateIn 
                :ready="animated" 
                :delay="200" 
                :string="getSubheader.text" 
            />

        </header>

        <div class="wrapper--intro-buttons">
            <animate-in :ready="animated" :delay="1100">
                <button
                    class="button button--purple"
                    @click="gotoPath('experienced')"
                    role="link"
                >
                    <span>Experienced Professional</span>
                </button>
            </animate-in>
            
            <animate-in :ready="animated" :delay="1300">
                <button
                    class="button button--coral-dark"
                    @click="gotoPath('student')"
                    role="link"
                >
                    <span>Student Or Recent Graduate</span>
                </button>
            </animate-in>

            <animate-in :ready="animated" :delay="1400">
                <button 
                    class="button button--purple" 
                    @click="gotoPath('recruit')"
                    role="link"
                >
                    <span>How We Recruit</span>
                </button>
            </animate-in>
        </div>

        <!-- <animate-in :ready="animated" :delay="1000">
            <button class="button button--purple" :disabled="ready" @click="next">
                <span>Discover your purple</span>
            </button>
        </animate-in> -->
        

    </article>
    <!-- <article class="intro__slide" v-else>

        <p class=headline>
            <template v-for="(line, l) in getHeader">
                <span :key="`intro-text-${l}`" v-html="line.text"></span>
            </template>
        </p>
        <div role="form">

            <animate-in :ready="ready" :delay="400">
                <input type="text" placeholder="Your first name" v-model="username">
            </animate-in>
            <animate-in :ready="ready" :delay="700" :string="getSubheader.text" />

            <div data-flex="row center">
                <animate-in :ready="ready" :delay="1000">
                    <button
                        class="button button--blue"
                        @click.once="click('experienced')"
                        role="link">
                        <span>an Experienced Professional</span>
                    </button>
                </animate-in>
                <animate-in :ready="ready" :delay="1100">
                    <span class="or">OR</span>
                </animate-in>
                <animate-in :ready="ready" :delay="1200">
                    <button
                        class="button button--orange"
                        @click.once="click('student')"
                        role="link">
                        <span>a Student or Recent Graduate</span>
                    </button>
                </animate-in>
            </div>

        </div>

    </article> -->
</template>

<script>
import { mapGetters } from 'vuex'

import AnimateIn                from '../Ui/Animate'
import IntroSlideTitle          from './IntroSlideTitle'

export default {
    name: 'IntroSlide',
    props: ['view', 'ready'],
    components: {
        IntroSlideTitle,
        AnimateIn
    },
    data() {
        return {
            username: '',
            animated: 0
        }
    },
    methods: {
        isHome() {
            return 'home' === this.view
        },
        handleIntroDelay( delay ) {
            setTimeout(() => {
                this.animated = true
            }, delay)
        },
        gotoPath( type ) {
            if (type === 'recruit') {
                return this.$router.push({ name: 'recruit-slide' })
            }

            this.$store.dispatch('setCredentials', {
                type
            }).then(() => {
                if (type === 'student') {
                    return this.$router.push({ name: 'campus-microsite' })
                }
                this.$router.push({ name: 'slide' })
            })
        },
    },
    computed: {
        getHeader() {
            const { header } = this.intro[ this.isHome() ? 0 : 1 ]
            return this.isMobile() && this.isHome() ? header[1] : header[0]
        },
        getSubheader() {
            const { subheader } = this.intro[ this.isHome() ? 0 : 1 ]
            return subheader[0]
        },
        ...mapGetters(['intro'])
    }
}
</script>
